export const GET_APP_PREFERENCES_STARTED = 'GET_APP_PREFERENCES_STARTED'
export const GET_APP_PREFERENCES_ERROR = 'GET_APP_PREFERENCES_ERROR'
export const GET_APP_PREFERENCES_SUCCESS = 'GET_APP_PREFERENCES_SUCCESS'
export const GET_PUBLIC_BRAND_PREFERENCES = 'GET_PUBLIC_BRAND_PREFERENCES'
export const SET_VENUES_APP_PREFERENCES = 'SET_VENUES_APP_PREFERENCES'
